import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

type BreadcrumbEntry = {
  label: string;
  url: string;
  queryParams?: { [key: string]: any };
};

@Component({
  selector: 'app-breadcrumb',
  imports: [CommonModule, RouterLink, RouterLinkActive],
  template: `
    @for (item of items(); track item.url + '-' + $index) {
      <a
        [routerLink]="item.url"
        [queryParams]="item.queryParams"
        routerLinkActive="font-semibold"
        [routerLinkActiveOptions]="{ exact: true }"
        class="truncate whitespace-nowrap"
        [ngClass]="{
          'max-w-96': $index === (items() ?? []).length - 1,
          'max-w-6 md:max-w-56 lg:max-w-96': $index !== (items() ?? []).length - 1,
        }"
        [title]="item.label">
        <span>{{ item.label }}</span>
      </a>

      @if ($index < (items() ?? []).length - 1) {
        <i class="pi pi-chevron-right shrink-0 !text-xs"></i>
      }
    }
  `,
  styles: [
    `
      :host {
        @apply flex items-center gap-2;
      }
    `,
  ],
  standalone: true,
})
export class BreadcrumbComponent {
  items = input<BreadcrumbEntry[]>();
}
